import React, { Component } from 'react';

import gif1 from "../images/gifs/SRI_90Days.webm";

import gif2 from "../images/gifs/SRI_180Days.webm";
import gif3 from "../images/gifs/SGWI.webm";

import gif4 from "../images/gifs/ET_2020-21.webm";
import gif5 from "../images/gifs/ET_2021-22.webm";
import gif6 from "../images/gifs/ET_2022-23.webm";
import gif7 from "../images/gifs/Rabi_2020-21.webm";
import gif8 from "../images/gifs/Rabi_2021-22.webm";
import gif9 from "../images/gifs/Rabi_2022-23.webm";
import gif10 from "../images/gifs/SnowCover.webm";
import gif11 from "../images/gifs/Snowmelt_1.webm";
import gif12 from "../images/gifs/Snowmelt_2.webm";
import gif13 from "../images/gifs/Rainfall.webm";
import gif14 from "../images/gifs/Runoff.webm";
import gif15 from "../images/gifs/SoilMoisture.webm";

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

import { MDBCarousel, MDBCarouselItem, MDBCarouselInner, MDBContainer, MDBRow, MDBCol } from 'mdbreact';

export default class HydrologyCarousel extends Component {

  constructor(props) {
    super(props);
    this.state = {
      activeSet: 1,
      files: [gif1,gif2,gif3,gif4,gif5,gif6,gif7,gif8,gif9,gif10,gif11,gif12,gif13,gif14,gif15],
      //files: [gif1,gif2,gif3,gif4,gif5,gif6,gif7,gif8,gif9],
      //files: [gif1,gif2,gif3,gif4,gif5,gif6,gif7,gif8,gif9,gif13,gif14,gif15],


      filesPerSet: 3,
      //names: ['Evapotranspiration1', 'Evapotranspiration2', 'Evapotranspiration3', 'Drought1', 'Drought2','Drought3', 'Irrigation1','Irrigation2','Irrigation3','Snowmelt1','Snowmelt2','Snowmelt3','Hydrological Modeling1','Hydrological Modeling2','Hydrological Modeling3'] };
      //names: ['Evapotranspiration1', 'Evapotranspiration2', 'Evapotranspiration3', 'Drought1', 'Drought2','Drought3', 'Irrigation1','Irrigation2','Irrigation3','Hydrological Modeling1','Hydrological Modeling2','Hydrological Modeling3'] };
names:["90-day SRI","180-day SRI","SGWI across Telangana","Evapotranspiration (2020-21)","Evapotranspiration (2021-22)","Evapotranspiration (2022-23)","Narayanpur Crop Maps (2020-21)","Narayanpur Crop Maps (2021-22)",
 "Narayanpur Crop Maps (2022-23)","Daily Snow Cover Maps","Daily Gridded Potential Snowmelt", "3-day Forecasted Snowmelt","Daily Rainfall","Daily Runoff","Daily Soil Moisture" ]
     // names: ['Evapotranspiration1', 'Evapotranspiration2', 'Evapotranspiration3', 'Drought1', 'Drought2','Drought3', 'Irrigation1','Irrigation2','Irrigation3'] };
  }
}

  handleNextSet = () => {
    const { activeSet, filesPerSet } = this.state;
    const totalSets = Math.ceil(this.state.files.length / filesPerSet);
    this.setState({
      activeSet: activeSet < totalSets ? activeSet + 1 : 1,
    });
  };

  handlePrevSet = () => {
    const { activeSet, filesPerSet } = this.state;
    const totalSets = Math.ceil(this.state.files.length / filesPerSet);
    this.setState({
      activeSet: activeSet > 1 ? activeSet - 1 : totalSets,
    });
  };
  render() {
  const { activeSet, filesPerSet, files, names } = this.state;
  const startIndex = (activeSet - 1) * filesPerSet;
  const endIndex = startIndex + filesPerSet;
  const filesToShow = files.slice(startIndex, endIndex);
  const namesToShow = names.slice(startIndex, endIndex);

  return (



      <Container  className=" d-flex flex-column ">
        <Row>
          <Col>
      <Container fluid className="big-title"> 

      <h2 className="blue-text1">Indian<span className="red-text1">Hydrology</span>At a Glance</h2>
      </Container></Col>
            </Row>
            <Row>
              <Col>


<Container fluid className="Hydrology-container">
  <div>
  
<MDBContainer>
        <MDBRow>
          <MDBCol>
            <MDBCarouselInner>
              <MDBRow>
                {filesToShow.map((file, index) => (
                  <MDBCol key={index}>
                    <div style={{ position: 'relative',display:'flex' }}>
                      {/* <img
                        className="d-block w-100"
                        src={file}
                        alt={`Slide ${index + 1}`}
                   
                        style={{
                          width: '100%',             // Full-width to fit parent container
                          maxWidth: '500px',         // Optional: Limit maximum width for large screens
                          height: 'auto',            // Maintains aspect ratio
                          objectFit: 'cover',        // Ensures the image covers the container area
                          borderRadius: '0px',
                          border: '5px solid #217CA3',
                          paddingTop: '30px'
                        }}
                      /> */}
                       <video
                          className="d-block w-100"
                          src={file}
                          autoPlay
                          loop
                          muted
                          style={{
                            width: '100%',             // Full-width to fit parent container
                            maxWidth: '500px',         // Optional: Limit maximum width for large screens
                            height: 'auto',            // Maintains aspect ratio
                            objectFit: 'cover',        // Ensures the video covers the container area
                            borderRadius: '0px',
                            border: '5px solid #217CA3',
                            paddingTop: '30px'
                          }}
                        >
                          Your browser does not support the video tag.
                      </video>
                      
                      
                      <div class="hydrologyTitle">
                        {namesToShow[index]}
                      </div>
                    </div>
                  </MDBCol>
                ))}
              </MDBRow>
            </MDBCarouselInner>
          </MDBCol>
        </MDBRow>
     
      
     
      <div
        style={{
           width: "35px", /* Adjust the size of the circle */
        height: "35px",/* Adjust the size of the circle */
        borderRadius:"50%",
          position: 'absolute',
          top: '50%',
          left: "-0.8%",
          display: "flex",
  justifyContent:"center",
  alignItems: "center",
  color: "white",
          backgroundColor: '#F55449',
          zIndex: '999',
        }}
      >   
        <FontAwesomeIcon
          icon={faChevronLeft}
          size="1x"
          borderRadius="50%"
         
          backgroundColor="#F55449"

          onClick={this.handlePrevSet}
          style={{ cursor: 'pointer' }}
       

        /></div>
          <div
        style={{
          position: 'absolute',
          top: '50%',
          right: "-0.8%",
          width: "35px", /* Adjust the size of the circle */
          height: "35px",/* Adjust the size of the circle */
          borderRadius:"50%",      
         display: "flex",
        justifyContent:"center",
        alignItems: "center",
        color: "white",
          backgroundColor: '#F55449',
          zIndex: '999',
        }}
      >

        <FontAwesomeIcon

          icon={faChevronRight}
          backgroundColor="#F55449"

          size="1x"
          onClick={this.handleNextSet}
          paddingTop='0px'
          style={{ cursor: 'pointer' }}
        />
        
      </div>
      </MDBContainer>
</div>
</Container>
  </Col>
  </Row>
</Container>

  );
}
}
 
  
  
